import React from "react"
import { RiExternalLinkLine } from 'react-icons/ri'

 
 

class Footer extends React.Component {
  constructor(props) {
    super(props)
    this.myRef = React.createRef()
    this.state = {
       
    }
   
  }
 

 

  render() {
    return (

        <footer >
        <div className="column-wrapper">
        <div> <svg className="logo-color-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250.9 48.6" width="250.9" height="48.6" overflow="visible"><path d="M19.7 31.8l-1.6-1.6c-2.1 2-4.1 3.2-7.1 3.2-4.8 0-8.5-4-8.5-9.1s3.6-9 8.5-9c3 0 5 1.3 6.9 3l1.7-1.8C17.4 14.4 15 13 11.1 13 4.6 13 0 18.1 0 24.3c0 6.3 4.7 11.3 11 11.3 3.9 0 6.4-1.5 8.7-3.8m4.5 3.5h2.5V13.4h-2.5v21.9zm27 0l-6.7-8.9c3.4-.6 5.9-2.7 5.9-6.4 0-3.9-3.1-6.5-7.9-6.5h-9.4v21.9h2.5v-8.5h6.3l6.3 8.5h3zM47.9 20c0 2.8-2.3 4.5-5.6 4.5h-6.7v-8.9h6.8c3.5.1 5.5 1.7 5.5 4.4M73 31.8l-1.6-1.6c-2.1 2-4.1 3.2-7.1 3.2-4.8 0-8.5-4-8.5-9.1s3.6-9 8.5-9c3 0 5 1.3 6.9 3l1.7-1.8c-2.2-2.1-4.6-3.5-8.5-3.5-6.4 0-11.1 5.1-11.1 11.3 0 6.3 4.7 11.3 11 11.3 3.9 0 6.4-1.5 8.7-3.8m13.7-18.6h-2.3l-10 22H77l2.6-5.8h11.9l2.6 5.8h2.7l-10.1-22zm3.8 14.1h-10l5-11.2 5 11.2zm28.7-3c0-6.2-4.8-10.9-11.6-10.9H100v21.9h7.6c6.8 0 11.6-4.8 11.6-11m-2.6 0c0 4.9-3.5 8.6-9.1 8.6h-5.1V15.7h5.1c5.6 0 9.1 3.8 9.1 8.6m22.7-10.9h-15.8v21.9h16V33H126v-7.7h11.9V23H126v-7.5h13.3v-2.1zm21 17.5l-13.8-17.5h-2.3v21.9h2.4v-18l14.1 17.9h2V13.4h-2.4v17.5zm26.4.9l-1.6-1.6c-2.1 2-4.1 3.2-7.1 3.2-4.8 0-8.5-4-8.5-9.1s3.6-9 8.5-9c3 0 5 1.3 6.9 3l1.7-1.8c-2.2-2.1-4.6-3.5-8.5-3.5-6.4 0-11.1 5.1-11.1 11.3 0 6.3 4.7 11.3 11 11.3 3.9 0 6.4-1.5 8.7-3.8m20.1-18.4H191v21.9h16V33h-13.5v-7.7h11.9V23h-11.9v-7.5h13.3v-2.1z" /><path className="st0" d="M238.6 22.8h10.3l-1.8-4.7-4.3-.3L244 10l-2.3-6.1z" /><path className="st1" d="M238.3 2.6L234.5.8l2.6 12.1zM234 48.6l4.2-1.8-1.1-10.5z" /><path className="st0" d="M229.9 0l-3.8 6.1 3.7 11.2-9.7-1.1-4 6.6h20.5z" /><path className="st2" d="M238.8 25.9H249l-1.8 4.7-4.3.4 1.2 7.7-2.3 6.1zM230 48.6l-3.5-5.8 3.4-11.5-10.6-.1-3.1-5.4h20.5z" /><path className="st0" d="M249 10.4c.2 0 .3-.1.3-.4 0-.2-.1-.3-.3-.3h-.3v.7h.3zm-.7-1h.8c.4 0 .7.2.7.6 0 .3-.2.5-.4.5l.1.1.4.8h-.4l-.4-.8h-.3v.8h-.4v-2zm.7 2.6c.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6-.9 0-1.5.7-1.5 1.6-.1.9.6 1.6 1.5 1.6m0-3.6c1.1 0 2 .9 2 2s-.9 2-2 2-1.9-.9-1.9-2c-.1-1.1.8-2 1.9-2" /></svg>

        <a href="tel:303.413.8800">303.413.8800</a>
																<a href="tel:1.888.598.0799">1.888.598.0799</a>
																<a href="mailto:info@circadence.com">info@circadence.com</a>
                                <ul className="branches-locations">
																<li>Headquarters – Project Ares by Circadence<sup>&reg;</sup>: <span>Boulder, CO</span></li>
															</ul>
 </div>
        <div><h4>Company</h4>
                                {/* <a href="/about-us">About Us</a>
																<a href="/leadership">Leadership</a> */}
                                <a href="/blog">Our Blog</a>
                                <a href="/jobs">Careers</a>
																<a href="/news/">News</a>
																<a href="https://projectares.academy/subscribe-to-newsletter" target="_blank">Subscribe to our Newsletter <RiExternalLinkLine style={{ position: 'relative', top: 2, marginLeft: 4 }} /></a>
                                <a href="https://marketing.circadence.com/acton/fs/blocks/showLandingPage/a/36273/p/p-00f8/t/page/fm/0">Partner with Us</a>

                                </div>
        <div><h4>Follow Us</h4>
        <div className="icon-wrapper">
        <a href="https://www.facebook.com/Circadence/" target="_blank">
        <svg xmlns="http://www.w3.org/2000/svg" aria-label="Facebook" role="img" viewBox="0 0 512 512"><rect width="512" height="512" rx="15%" fill="#1877f2"/><path d="M355.6 330l11.4-74h-71v-48c0-20.2 9.9-40 41.7-40H370v-63s-29.3-5-57.3-5c-58.5 0-96.7 35.4-96.7 99.6V256h-65v74h65v182h80V330h59.6z" fill="#fff"/></svg> 

            </a>


            <a href="https://www.linkedin.com/company/circadence/" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" aria-label="LinkedIn" role="img" viewBox="0 0 512 512" fill="#fff"><rect width="512" height="512" rx="15%" fill="#0077b5"/><circle cx="142" cy="138" r="37"/><path stroke="#fff" strokeWidth="66" d="M244 194v198M142 194v198"/><path d="M276 282c0-20 13-40 36-40 24 0 33 18 33 45v105h66V279c0-61-32-89-76-89-34 0-51 19-59 32"/></svg>

            </a>

            <a href="https://twitter.com/Circadence" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" aria-label="Twitter" role="img" viewBox="0 0 512 512"><rect width="512" height="512" rx="15%" fill="#1da1f2"/><path fill="#fff" d="M437 152a72 72 0 01-40 12a72 72 0 0032-40a72 72 0 01-45 17a72 72 0 00-122 65a200 200 0 01-145-74a72 72 0 0022 94a72 72 0 01-32-7a72 72 0 0056 69a72 72 0 01-32 1a72 72 0 0067 50a200 200 0 01-105 29a200 200 0 00309-179a200 200 0 0035-37"/></svg>
            </a>

            <a href="https://www.youtube.com/user/Circadence/videos" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" aria-label="YouTube" role="img" viewBox="0 0 512 512" fill="#ed1d24"><rect width="512" height="512" rx="15%"/><path d="m427 169c-4-15-17-27-32-31-34-9-239-10-278 0-15 4-28 16-32 31-9 38-10 135 0 174 4 15 17 27 32 31 36 10 241 10 278 0 15-4 28-16 32-31 9-36 9-137 0-174" fill="#fff"/><path d="m220 203v106l93-53"/></svg>
            </a>

            </div>
        </div>
         </div>
          <span> Circadence &copy; {new Date().getFullYear()} - <a href="https://circadence.com/terms-conditions" style={{ color: '#28b4ff' }}>Terms &amp; Conditions</a> - <a target="_blank" href="https://news.projectares.academy/wp-content/uploads/2020/01/Privacy-Policy.pdf" style={{ color: '#28b4ff' }}>Privacy Policy</a></span>

        </footer>
     
    )
  }
}

 

export default Footer